class SuperAdminService {
  constructor() {}

  async GetPage(page, limit = 20, searchText = "") {
    if (page === undefined) page = 1;
    let pageResponse = await window.$A.Api.post(
      `/super-admin/customer/${page}/${limit}`,
      {
          searchAllFields: searchText,
          filter: {},
      },
      {
        headers: {
          "Content-Type": "application/json",
          AccessToken: window.$A.Auth.apiToken.token,
        },
        timeout: 10000,
      }
    )
      .then(function (res) {
        return res.data;
      })
      .catch(function (e) {
        console.log(e);
        return {results: []};
      });

    return pageResponse;
  }

  // Throws on failure so the page can show an error instead of an empty list.
  async GetAccountHealth() {
    let response = await window.$A.Api.get(`/super-admin/account-health`, {
      headers: {
        AccessToken: window.$A.Auth.apiToken.token,
      },
      timeout: 30000,
    });

    // The api answers 200 with {success: false} on Access Denied.
    if (!Array.isArray(response.data)) {
      throw new Error(response.data.message);
    }

    return response.data;
  }

  async GetBusinessReview(accountId) {
    let response = await window.$A.Api.get(`/super-admin/business-review/${accountId}`, {
      headers: {
        AccessToken: window.$A.Auth.apiToken.token,
      },
      timeout: 30000,
    });

    if (!response.data.account) {
      throw new Error(response.data.message);
    }

    return response.data;
  }
}

export default SuperAdminService;
